<router-outlet></router-outlet>
<app-loader *ngIf="loader$ | async"></app-loader>
